import { AnyAction } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';

import { MessageResponse } from '../../../_helpers/iResponse';
import * as Constants from '../constants';
import {IDashboard, IResponseDashboard} from '../reducers';
import * as Services from '../services';

function* getDashboardInfo(action: AnyAction) {
  try {
    const payload: IDashboard = yield call(Services.getDashboardInfo);
    yield put({
      type: Constants.GET_DASHBOARD_INFO_SUCCESS,
      payload
    });
    return action.resolve(true);
  } catch (e) {
    yield put({ type: Constants.GET_DASHBOARD_INFO_FAILED, e });
    return action.reject(e);
  }
}

export const dashboardSagas = [takeLatest(Constants.GET_DASHBOARD_INFO, getDashboardInfo)];
